/** Pure presentation helpers. No DOM, no framework — covered directly by bun test. */

export function formatRating(value) {
  if (!value || Number.isNaN(value)) return "New";
  return (Math.round(value * 10) / 10).toFixed(1);
}

export function ratingLabel(value, count) {
  if (!count) return "No reviews yet";
  const noun = count === 1 ? "review" : "reviews";
  return `${formatRating(value)} · ${count} ${noun}`;
}

/** Filled/half/empty star buckets for a 0–5 rating. */
export function starBuckets(value) {
  const rounded = Math.round((Number(value) || 0) * 2) / 2;
  return Array.from({ length: 5 }, (_, i) => {
    const position = i + 1;
    if (rounded >= position) return "full";
    if (rounded + 0.5 >= position) return "half";
    return "empty";
  });
}

export function priceLabel(level) {
  const n = Math.min(4, Math.max(1, Number(level) || 1));
  return "$".repeat(n);
}

export function formatLocation(restaurant) {
  if (!restaurant) return "";
  return [restaurant.city, restaurant.state].filter(Boolean).join(", ");
}

const RELATIVE_UNITS = [
  ["year", 31536000],
  ["month", 2592000],
  ["week", 604800],
  ["day", 86400],
  ["hour", 3600],
  ["minute", 60],
];

/** "3 days ago" — falls back to the raw value when it isn't a date we understand. */
export function relativeTime(iso, now = Date.now()) {
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return "";
  const seconds = Math.max(0, Math.floor((now - then) / 1000));
  if (seconds < 45) return "just now";
  for (const [unit, size] of RELATIVE_UNITS) {
    if (seconds >= size) {
      const amount = Math.floor(seconds / size);
      return `${amount} ${unit}${amount === 1 ? "" : "s"} ago`;
    }
  }
  return "just now";
}

export function initials(name) {
  if (!name) return "?";
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

/** Deterministic warm accent per name, so avatars stay stable between visits. */
export function avatarTint(name) {
  const palette = ["#e2643a", "#6f8f6a", "#e8b04b", "#7b5ea7", "#3f8fa0", "#c96a8b"];
  let hash = 0;
  for (const char of String(name ?? "")) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return palette[hash % palette.length];
}

export function pluralize(count, singular, plural = `${singular}s`) {
  return `${count} ${count === 1 ? singular : plural}`;
}

export function truncate(text, max = 160) {
  const value = String(text ?? "");
  if (value.length <= max) return value;
  return `${value.slice(0, max - 1).trimEnd()}…`;
}
